export enum ErrorCodes {
  QUEUE_PENDING_OPERATIONS = 'QUEUE_PENDING_OPERATIONS',
  UNAUTHORIZED = 'GLOBAL401',
  NOT_FOUND = 'GLOBAL404',
  SERVER_ERROR = 'GLOBAL500'
}
